import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var BREEDS_ENDPOINT = {
    GET: "/Breeds"
};
/**
 * BreedsApiClient - client for fetching Breeds from BFF endpoints
 * @export
 * @class BreedsApiClient
 * @extends {BaseApiClient}
 */
var BreedsApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(BreedsApiClient, _super);
    function BreedsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch breeds from BFF
     * @throws {RequiredError}
     * @memberof BreedsApiClient
     */
    BreedsApiClient.prototype.getBreeds = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(BREEDS_ENDPOINT.GET, fetchOptions);
    };
    return BreedsApiClient;
}(BaseApiClient));
export { BreedsApiClient };
//# sourceMappingURL=BreedsApiClient.js.map